// JavaScript program for the above approach

// Function to calculate sum of
// all proper divisors of num
const divSum = (num: number) => {
  // Final result of summation
  // of divisors
  let result = 0;

  // Find all divisors of num
  for (let i = 2; i <= Math.sqrt(num); i++) {
      // If 'i' is divisor of 'num'
      if (num % i == 0) {
        // If both divisors are same
        // then add it only once else
        // add both
        if (i == num / i) {
            result += i;
        } else {
            result += i + num / i;
        }
      }
  }

  // Add 1 to the result as
  // 1 is also a divisor
  return result + 1;
}
  
// Function to check if N is a
// Untouchable Number
export const isUntouchable = (num: number) => {
  for (let i = 1; i <= 2 * num; i++) {
    if (divSum(i) == num) return false;
  }
  return true;
}